<div id="offers" *ngIf="!fetching">
  <app-offer
  class="offer"
  (actioned)="onOfferActioned($event)"
  [offer]="offer"
  [maxPlanTypeLength] ="maxPlanTypeLength"
  [quoteRequestState]="quote?.quoteRequestState"
  [inputAnnualUsage]="quote?.inputAnnualUsage"
  [isAllMarginChanged] = "this.isAllMarginChanged"
  *ngFor="let offer of this.filteredPrices$ | async"
  ></app-offer>
</div>
